import type { SVGProps } from "react";

export function IconDarkPurpleAtmWithdrawal(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 34 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.625 28.875V19.4657C4.625 18.007 5.20446 16.608 6.23591 15.5766L10.125 11.6875M10.125 4.125V11.6875M29.375 4.125V28.875H14.25L18.375 24.75C19.5141 23.6109 19.5141 21.7641 18.375 20.625V20.625C17.2359 19.4859 15.3891 19.4859 14.25 20.625L10.125 24.75V11.6875M19.75 15.125L24.5625 10.3125M19.75 15.125L14.9375 10.3125M19.75 15.125L19.75 4.125"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
